import React from 'react';

function StatusIcon({ type }) {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      case 'error':
        return '❌';
      case 'info':
        return 'ℹ️';
      default:
        return '⬜';
    }
  };

  return (
    <span className="text-lg">
      {getIcon()}
    </span>
  );
}

export default StatusIcon;
